<!-- This component is shown with an animation. We can not add another animation to this component (angular bug), so we create an extra sub-component as a solution -->

<tun-search-music-collection-result-content-view
  class="wrapper"
>
</tun-search-music-collection-result-content-view>
